"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseError = void 0;
const version_js_1 = require("./version.js");
class BaseError extends Error {
  constructor(shortMessage) {
    var _args$cause;
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const details = args.cause instanceof BaseError ? args.cause.details : (_args$cause = args.cause) !== null && _args$cause !== void 0 && _args$cause.message ? args.cause.message : args.details;
    const docsPath = args.cause instanceof BaseError ? args.cause.docsPath || args.docsPath : args.docsPath;
    const message = [shortMessage || 'An error occurred.', '', ...(args.metaMessages ? [...args.metaMessages, ''] : []), ...(docsPath ? ["Docs: https://abitype.dev".concat(docsPath)] : []), ...(details ? ["Details: ".concat(details)] : []), "Version: abitype@".concat(version_js_1.version)].join('\n');
    super(message);
    Object.defineProperty(this, "details", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "docsPath", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "metaMessages", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shortMessage", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'AbiTypeError'
    });
    if (args.cause) this.cause = args.cause;
    this.details = details;
    this.docsPath = docsPath;
    this.metaMessages = args.metaMessages;
    this.shortMessage = shortMessage;
  }
}
exports.BaseError = BaseError;
//# sourceMappingURL=errors.js.map